<template>
    <div>
        <button class="ds-btn" @click="isModalVisible = true">Pievienot uzņēmumu</button>

        <b-modal v-model="isModalVisible" no-close-on-backdrop hide-footer body-class="p-2" header-class="bg-light align-items-center" size="lg">
            <div slot="modal-title">
                <h3 class="h4 text-dark font-weight-light m-0">Jauns uzņēmums</h3>
            </div>
            <div slot="modal-header-close">
            </div>
            <CompaniesBaseForm @finished="handleCompanyCreation"/>
        </b-modal>
    </div>
</template>
<script>
    import {mapActions} from 'vuex';

    import CompaniesBaseForm from './CompaniesBaseForm';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';

    export default {
        name: 'companies-add',
        components: {CompaniesBaseForm},
        data: () => ({isModalVisible: false}),
        methods: {
            ...mapActions('company', {
                /** @type {function|*} */
                getCompanies: companyStoreTypes.ACTION_GET_COMPANIES,
            }),
            handleCompanyCreation() {
                this.isModalVisible = false;
                this.getCompanies();
            },
        },
    }
</script>